import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var AlarmCheck = createReactComponent("AlarmCheck", ["svg", defaultAttributes, [["path", {
  d: "M12 21a8 8 0 100-16 8 8 0 000 16z",
  key: "ubbk1n"
}], ["path", {
  d: "M5 3L2 6",
  key: "yo78bm"
}], ["path", {
  d: "M22 6l-3-3",
  key: "ry34ie"
}], ["path", {
  d: "M6 19l-2 2",
  key: "1dpmc8"
}], ["path", {
  d: "M18 19l2 2",
  key: "1v10ht"
}], ["path", {
  d: "M9 13l2 2 4-4",
  key: "brbdw6"
}]]]);
export default AlarmCheck;